export type SortDirection = "asc" | "desc";

// `aria-sort` for a column, given the table's current sort. Lives apart from
// `SortableTableHeader` so that component file exports only components.
export const ariaSortFor = (
  column: string,
  orderBy: string | undefined,
  orderDir: SortDirection | undefined
): "ascending" | "descending" | "none" =>
  orderBy !== column || orderDir === undefined
    ? "none"
    : orderDir === "asc"
      ? "ascending"
      : "descending";
